export const FiltersDataConstants = {
  GET_MARKETS: 'GET_MARKETS',
  SET_MARKETS: 'SET_MARKETS',
  SET_LOADED: 'SET_LOADED',
  GET_MEMBERS: 'GET_MEMBERS',
  SET_MEMBERS: 'SET_MEMBERS',
  SET_MEMBERS_LOADED: 'SET_MEMBERS_LOADED',
  GET_ADMIN_ROLES: 'GET_ADMIN_ROLES',
  SET_ADMIN_ROLES: 'SET_ADMIN_ROLES',
  SET_ADMIN_ROLES_LOADED: 'SET_ADMIN_ROLES_LOADED',
}
